// const format = 'XXX-XXX-XXXX';
// const format = '(XXX) XXX-XXXX';
const getFormat = () => {
  const format = root.app.settings?.phone_format;
  // return null;
  if (!['XXX-XXX-XXXX', '(XXX) XXX-XXXX'].includes(format)) return null;
  return format;
};

export function cleanPhone(value) {
  if (!value) return value;
  const cleaned = ('' + value).replace(/[^0-9.+()-]/g, '');
  return cleaned;
}

export function formatPhoneNumber(phoneNumberString, cutExtraNumbers) {
  // skip formatting if starts with "+"
  if (phoneNumberString && phoneNumberString[0] === '+') {
    return cleanPhone(phoneNumberString);
  }
  const format = getFormat();
  if (!format) return phoneNumberString;

  const cleaned = ('' + phoneNumberString).replace(/\D/g, '');
  // console.log('clean:', cleaned, format);

  let v = '';
  if (format === 'XXX-XXX-XXXX') {
    if (!cutExtraNumbers && cleaned.length > 10) return phoneNumberString;
    v = cleaned.substr(0, 3);
    if (cleaned.length > 3) v += '-' + cleaned.substr(3, 3);
    if (cleaned.length > 6) v += '-' + cleaned.substr(6, 4);
  }
  if (format === '(XXX) XXX-XXXX') {
    if (!cutExtraNumbers && cleaned.length > 10) return phoneNumberString;
    v = '(' + cleaned.substr(0, 3);
    if (cleaned.length > 3) v += ') ' + cleaned.substr(3, 3);
    if (cleaned.length > 6) v += '-' + cleaned.substr(6, 4);
  }
  return v;
}
